import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { DiscussionFeedComponent } from "./discussion-feed.component";
import { DiscussionFeedAuthResolver } from "./discussion-feed-auth-resolver.service";

const routes: Routes = [
  {
    path: "", // path is "home"
    component: DiscussionFeedComponent,
    resolve: {
      isAuthenticated: DiscussionFeedAuthResolver,
    },
    data: {
      title: "Discussion Feed",
      icon: "ti-check-box",
      caption: "Take  your pick of the most interesting stories",
      status: true,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DiscussionFeedRoutingModule {}
